var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-admin-body"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-guide"},[_c('embed',{attrs:{"src":"./guides/quickguide.pdf","type":"application/pdf","width":"100%","height":"800px"}})])
}]

export { render, staticRenderFns }